import ProductContainerFilter from './ProductContainerFilter.jsx';

export default ProductContainerFilter;


// WEBPACK FOOTER //
// ./src/components/ProductContainerFilter/index.jsx